export const HOME_DRAFTS_QUERY_TASK_NAME = 'HomeDraftsQuery';
